import TableCustomizationPanel from "./TableCustomizationPanel";

export default TableCustomizationPanel;